module.exports = __webpack_public_path__ + "assets/images/pages/medipremium/icon-medipremium-3.png?f6937885";